import SuperpoderesPage from './SuperpoderesPage';

/**
 * Landing de acceso para usuarios existentes.
 *
 * Mantiene exactamente la experiencia visual de SuperpoderesPage, pero cambia
 * sus CTAs para abrir el modal de ingreso de la plataforma.
 */
export default function OnlinePage() {
    return <SuperpoderesPage ctaMode="login" />;
}